import { LOGIN, SET_SELECTED_USER, SET_USERS_LIST } from "./types";
import history from "../history";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getUser = (userID, TYPE) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/users/${userID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: TYPE, payload: response.data.user });
    }
    catch (error) { errorHandler(error, null); }
};

export const getAllUsers = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/users/all`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_USERS_LIST, payload: response.data.users });
    }
    catch (error) { errorHandler(error, null); }
};

export const getSubordinateUsers = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/users/subordinate`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_USERS_LIST, payload: response.data.subordinate });
    }
    catch (error) { errorHandler(error, null); }
};

export const startActivation = (onSuccess) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post("/api/users/activate", {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) onSuccess();
    }
    catch (error) { errorHandler(error, null); }
};

export const activate = (token, formValues, onFieldError) => async (dispatch) => {
    try {
        const { data } = await backend.patch(`/api/users/activate/${token}`, { ...formValues }, {
            headers: { 
                "Content-Type": "application/json"
            }
        });
        
        if (data.token) dispatch({ type: LOGIN, payload: data });
        history.push("/");
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const updateUserPassword = (formValues, onFieldError, onSuccess) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/users/pass/${store.getState().auth.userID}`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) onSuccess();
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const updateUserPin = (formValues, onFieldError, onSuccess) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/users/pin/${store.getState().auth.userID}`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) onSuccess();
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const toggleUserLeave = (userID, leave, onSuccess) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/users/leave/${userID}`, { leave }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_SELECTED_USER, payload: response.data.user });
            onSuccess();
        }
    }
    catch (error) { errorHandler(error, null); }
};

export const toggleUserLocked = (userID, message, onSuccess, onFieldError) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/users/locked/${userID}`, { message }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_SELECTED_USER, payload: response.data.user });
            onSuccess();
        }
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const resetPass = (formValues, onSuccess, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/users/pass`, { ...formValues }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
        });

        if (response) onSuccess();
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const resetUserPass = (userID, message, onSuccess, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.delete(`/api/users/pass/${userID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) onSuccess();
    }
    catch (error) { errorHandler(error, onFieldError); }
};